/**
 * Sleeve Stars — Mega-menu controller.
 *  - Hover opens the panel; small delay before closing prevents flicker when
 *    moving the cursor from the trigger to the panel.
 *  - Clicking the top-level trigger that has a submenu PREVENTS navigation
 *    and instead toggles the panel (so the menu doesn't disappear when you
 *    click it). A "View all" link inside the panel handles parent navigation.
 *  - On touch devices the first tap opens, second tap navigates.
 *  - Esc closes; outside click closes; focus-within keeps open for keyboards.
 */
(function () {
  const CLOSE_DELAY = 200;
  const items = document.querySelectorAll('.ss-mega__bar-item');
  if (!items.length) return;

  const supportsHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;
  let openItem = null;
  let closeTimer = null;

  function openPanel(li) {
    if (openItem && openItem !== li) closeNow(openItem);
    li.classList.add('is-open');
    const trig = li.querySelector('.ss-mega__trigger');
    if (trig) trig.setAttribute('aria-expanded', 'true');
    openItem = li;
  }

  function closeNow(li) {
    li.classList.remove('is-open');
    const trig = li.querySelector('.ss-mega__trigger');
    if (trig) trig.setAttribute('aria-expanded', 'false');
    if (openItem === li) openItem = null;
  }

  function scheduleClose(li) {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(() => closeNow(li), CLOSE_DELAY);
  }

  function cancelClose() {
    clearTimeout(closeTimer);
    closeTimer = null;
  }

  items.forEach(li => {
    const panel = li.querySelector('.ss-mega__panel');
    const trig = li.querySelector('.ss-mega__trigger');
    if (!panel || !trig) return;

    // Hover: open on mouseenter, close after delay on mouseleave
    li.addEventListener('mouseenter', () => { cancelClose(); openPanel(li); });
    li.addEventListener('mouseleave', () => scheduleClose(li));
    panel.addEventListener('mouseenter', cancelClose);
    panel.addEventListener('mouseleave', () => scheduleClose(li));

    // Click on trigger: if panel has children, toggle instead of navigating
    trig.addEventListener('click', (ev) => {
      if (!panel.querySelector('.ss-mega__tile')) return; // empty panel, allow nav
      if (li.classList.contains('is-open') && !supportsHover) {
        // second tap on touch = navigate
        return;
      }
      ev.preventDefault();
      if (li.classList.contains('is-open')) closeNow(li);
      else openPanel(li);
    });

    // Keyboard: focus-within opens; Escape closes
    li.addEventListener('focusin',  () => { cancelClose(); openPanel(li); });
    li.addEventListener('focusout', (ev) => {
      if (!li.contains(ev.relatedTarget)) scheduleClose(li);
    });
  });

  // Esc anywhere closes the open panel
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && openItem) {
      closeNow(openItem);
    }
  });

  // Click outside closes
  document.addEventListener('click', (e) => {
    if (!openItem) return;
    if (!openItem.contains(e.target)) closeNow(openItem);
  });
})();
